<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16.001"><g><path d="m104.284 69.593-4.043-2.235-.242-.134-.242.134-4.042 2.235.778-4.772.04-.25-.175-.18-3.32-3.403 4.565-.697.264-.04.113-.242 2.02-4.302 2.019 4.302.113.241.264.04 4.565.698-3.32 3.403-.176.18.04.25.779 4.772z" style="stroke:none;fill:#ffc455" transform="translate(-92 -54.527)" fill="currentColor"/><path d="m100 56.883-1.794 3.821-4.131.631 2.993 3.068-.694 4.254 3.625-2.004 3.626 2.004-.694-4.254 2.993-3.068-4.131-.63-1.794-3.822m0-2.353 2.472 5.266 5.528.845-4 4.1.944 5.788L100 67.796l-4.944 2.733L96 64.74l-4-4.1 5.527-.844L100 54.53z" style="fill:#fab83b;stroke:none" transform="translate(-92 -54.527)" fill="currentColor"/></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-favor-on',
});
</script>
